export enum OrderStatus {
  NEW,
  PENDING,
  COMPLETED,
}
